export const titleFormatter = (str, hyphensToKeep = 0) => {
    let formattedStr = str.slice(0);

    if (formattedStr.indexOf('-') !== -1) {
        if (hyphensToKeep === 0) {
            formattedStr = formattedStr.replace(/-/g, ' ');
        } else {
            const formattedStrParts = formattedStr.split('-');
            formattedStr = '';
            let hyphensKept = 0;
            let idx = 0;

            // loop through the parts and add hyphens until we either have kept the number we wanted to
            // or we reach the end of the string
            while (hyphensToKeep > hyphensKept && idx < formattedStrParts.length) {
                formattedStr += conditionallyCapitalize(formattedStrParts[idx]) + '-';
                hyphensKept++;
                idx++;
            }

            // if we haven't reached the end of the string but still have hyphens to go, loop over the
            // remaining string parts
            for (idx; idx < formattedStrParts.length; idx++) {
                formattedStr += conditionallyCapitalize(formattedStrParts[idx]) + ' ';
            }

            return formattedStr;
        }
    } else {
        formattedStr = formattedStr.replace(/([A-Z])/g, ' $1');
    }

    formattedStr = formattedStr.split(' ');

    for (let i = 0; i < formattedStr.length; i++) {
        formattedStr[i] = conditionallyCapitalize(formattedStr[i]);
    }

    return formattedStr.join(' ');
};

export const pageDepthCounter = (page) => {
    let pageArray = page.slice(1).split('/');

    return pageArray.length;
};

// Will return a String with at least the length specified
export const addLeadingPadding = (data, length, paddingData) => {
    if (data.toString().length >= length) {
        return data.toString();
    }

    return addLeadingPadding(paddingData.toString() + data, length, paddingData);
};

const conditionallyCapitalize = (str) => (str.length >= 3 ? str.charAt(0).toUpperCase() + str.slice(1) : str);
